// import { useEffect, useRef, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { Viewer } from "@photo-sphere-viewer/core";
// import { MarkersPlugin } from "@photo-sphere-viewer/markers-plugin";
// import "@photo-sphere-viewer/core/index.css";
// import "@photo-sphere-viewer/markers-plugin/index.css";
// import { apiUrl } from "../apiUrl";
// import "../styles/RoomPanoramaPage.css";

// const API_BASE = `${apiUrl}/api`;

// const RoomPanoramaPage = () => {
//   const { plotId, roomId } = useParams();
//   const navigate = useNavigate();

//   const containerRef = useRef(null);
//   const viewerRef = useRef(null);
//   const overlayRef = useRef(null);

//   const [room, setRoom] = useState(null);
//   const [unit, setUnit] = useState(null);
//   const [fetchError, setFetchError] = useState(null);
//   const [isFetching, setIsFetching] = useState(true);
//   const [isLoaded, setIsLoaded] = useState(false);
//   const [showHeader, setShowHeader] = useState(false);

//   // Fetch unit and room data
//   useEffect(() => {
//     const fetchAll = async () => {
//       try {
//         const unitRes = await fetch(`${API_BASE}/unit/${plotId}`, {
//           headers: { Accept: "application/json" },
//         });
//         if (!unitRes.ok) throw new Error("Unit not found");
//         const unitData = await unitRes.json();
//         setUnit(unitData);

//         const foundRoom = unitData.rooms?.find((r) => r.id === parseInt(roomId));
//         if (!foundRoom) throw new Error("Room not found");
//         setRoom(foundRoom);
//       } catch (err) {
//         setFetchError(err.message);
//       } finally {
//         setIsFetching(false);
//       }
//     };
//     fetchAll();
//   }, [plotId, roomId]);

//   // Initialize PSV viewer
//   useEffect(() => {
//     if (!room?.panorama_url || !containerRef.current) return;

//     let animationId;
//     let cleanupFunctions = [];

//     viewerRef.current = new Viewer({
//       container: containerRef.current,
//       panorama: room.panorama_url,
//       defaultZoomLvl: 50,
//       mousewheelCtrlKey: false,
//       loadingImg: null,
//       loadingTxt: "",
//       navbar: ["zoom", "move", "caption", "fullscreen"],
//       plugins: [[MarkersPlugin, { markers: [] }]],
//     });

//     viewerRef.current.addEventListener("ready", () => {
//       setIsLoaded(true);
//       setTimeout(() => setShowHeader(true), 300);

//       // Gentle auto-rotate
//       let angle = 0;
//       let isInteracting = false;
//       let resumeTimeout = null;

//       const rotate = () => {
//         if (!isInteracting && viewerRef.current) {
//           angle += 0.002;
//           viewerRef.current.rotate({ yaw: Math.sin(angle) * 0.05, pitch: 0 });
//         }
//         animationId = requestAnimationFrame(rotate);
//       };
      
//       animationId = requestAnimationFrame(rotate);

//       const onInteractionStart = () => {
//         isInteracting = true;
//         clearTimeout(resumeTimeout);
//       };

//       const onInteractionEnd = () => {
//         clearTimeout(resumeTimeout);
//         resumeTimeout = setTimeout(() => {
//           isInteracting = false;
//         }, 2000);
//       };

//       const container = containerRef.current;
//       container.addEventListener("mousedown", onInteractionStart);
//       container.addEventListener("touchstart", onInteractionStart);
//       container.addEventListener("mouseup", onInteractionEnd);
//       container.addEventListener("touchend", onInteractionEnd);

//       cleanupFunctions.push(() => {
//         cancelAnimationFrame(animationId);
//         clearTimeout(resumeTimeout);
//         container.removeEventListener("mousedown", onInteractionStart);
//         container.removeEventListener("touchstart", onInteractionStart);
//         container.removeEventListener("mouseup", onInteractionEnd);
//         container.removeEventListener("touchend", onInteractionEnd);
//       });
//     });

//     cleanupFunctions.push(() => {
//       if (viewerRef.current) {
//         viewerRef.current.destroy();
//         viewerRef.current = null;
//       }
//     });

//     return () => {
//       cleanupFunctions.forEach(fn => fn());
//     };
//   }, [room]);

//   // Entry fade-in effect
//   useEffect(() => {
//     if (!overlayRef.current) return;
//     overlayRef.current.style.opacity = "1";
//     overlayRef.current.style.transition = "none";
    
//     const timer = setTimeout(() => {
//       if (overlayRef.current) {
//         overlayRef.current.style.transition = "opacity 0.7s ease-out";
//         overlayRef.current.style.opacity = "0";
//       }
//     }, 50);
    
//     return () => clearTimeout(timer);
//   }, []);

//   const handleBack = () => {
//     if (overlayRef.current) {
//       overlayRef.current.style.transition = "opacity 0.4s ease-in";
//       overlayRef.current.style.opacity = "1";
//     }
//     setTimeout(() => navigate(`/unit/${plotId}`), 450);
//   };

//   const navigateToRoom = (roomId) => {
//     if (overlayRef.current) {
//       overlayRef.current.style.transition = "opacity 0.3s ease-in";
//       overlayRef.current.style.opacity = "1";
//     }
//     setTimeout(() => navigate(`/unit/${plotId}/room/${roomId}`), 320);
//   };

//   // Loading state
//   if (isFetching) {
//     return (
//       <div className="room-loading">
//         <div className="room-loading-card">
//           <div className="room-loading-icon">🚪</div>
//           <div className="room-loading-text">Loading room...</div>
//         </div>
//       </div>
//     );
//   }

//   // Error state
//   if (fetchError || !room) {
//     return (
//       <div className="room-error">
//         <div className="room-error-icon">⚠️</div>
//         <h2 className="room-error-title">{fetchError || "Room not found"}</h2>
//         <button onClick={() => navigate(-1)} className="room-error-btn">
//           ← Go Back
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div className="room-container">
//       {/* Header */}
//       <div className={`room-header ${showHeader ? 'room-header-visible' : 'room-header-hidden'}`}>
//         <button onClick={handleBack} className="room-back-btn">
//           ← Back to Unit
//         </button>
        
//         <span className="room-title">
//           🚪 {room.room_label}
//         </span>
        
//         <span className="room-subtitle">
//           Unit {unit?.plot_number}
//         </span>

//         {/* Other rooms quick navigation */}
//         {unit?.rooms?.length > 1 && (
//           <div className="room-nav">
//             {unit.rooms
//               .filter((r) => r.id !== parseInt(roomId))
//               .map((r) => (
//                 <button
//                   key={r.id}
//                   onClick={() => navigateToRoom(r.id)}
//                   className="room-nav-btn"
//                 >
//                   {r.room_label}
//                 </button>
//               ))}
//           </div>
//         )}
//       </div>

//       {/* Panorama Container */}
//       <div ref={containerRef} className="room-panorama" />

//       {/* Transition Overlay */}
//       <div ref={overlayRef} className="room-transition" />
//     </div>
//   );
// };

// export default RoomPanoramaPage;

import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Viewer } from "@photo-sphere-viewer/core";
import { MarkersPlugin } from "@photo-sphere-viewer/markers-plugin";
import "@photo-sphere-viewer/core/index.css";
import "@photo-sphere-viewer/markers-plugin/index.css";
import { apiUrl } from "../apiUrl";
import "../styles/RoomPanoramaPage.css";

const API_BASE = `${apiUrl}/api`;

const RoomPanoramaPage = () => {
  const { plotId, roomId } = useParams();
  const navigate = useNavigate();

  const containerRef = useRef(null);
  const viewerRef = useRef(null);
  const overlayRef = useRef(null);

  const [room, setRoom] = useState(null);
  const [unit, setUnit] = useState(null);
  const [fetchError, setFetchError] = useState(null);
  const [isFetching, setIsFetching] = useState(true);
  const [isLoaded, setIsLoaded] = useState(false);
  const [showHeader, setShowHeader] = useState(false);

  // Fetch unit and room data
  useEffect(() => {
    const fetchAll = async () => {
      try {
        const unitRes = await fetch(`${API_BASE}/unit/${plotId}`, {
          headers: { Accept: "application/json" },
        });
        if (!unitRes.ok) throw new Error("Unit not found");
        const unitData = await unitRes.json();
        setUnit(unitData);

        const foundRoom = unitData.rooms?.find((r) => r.id === parseInt(roomId));
        if (!foundRoom) throw new Error("Room not found");
        setRoom(foundRoom);
      } catch (err) {
        setFetchError(err.message);
      } finally {
        setIsFetching(false);
      }
    };
    fetchAll();
  }, [plotId, roomId]);

  // Initialize PSV viewer
  useEffect(() => {
    if (!room?.panorama_url || !containerRef.current) return;

    let animationId;
    let cleanupFunctions = [];

    // Reset overlay for new room
    if (overlayRef.current) {
      overlayRef.current.style.opacity = "0";
      overlayRef.current.classList.remove("room-transition-active");
    }
    
    setIsLoaded(false);
    setShowHeader(false);

    viewerRef.current = new Viewer({
      container: containerRef.current,
      panorama: room.panorama_url,
      defaultZoomLvl: 50,
      mousewheelCtrlKey: false,
      loadingImg: null,
      loadingTxt: "",
      navbar: ["zoom", "move", "caption", "fullscreen"],
      plugins: [[MarkersPlugin, { markers: [] }]],
    });

    viewerRef.current.addEventListener("ready", () => {
      setIsLoaded(true);
      setTimeout(() => setShowHeader(true), 300);

      // Gentle auto-rotate
      let angle = 0;
      let isInteracting = false;
      let resumeTimeout = null;

      const rotate = () => {
        if (!isInteracting && viewerRef.current) {
          angle += 0.002;
          viewerRef.current.rotate({ yaw: Math.sin(angle) * 0.05, pitch: 0 });
        }
        animationId = requestAnimationFrame(rotate);
      };
      
      animationId = requestAnimationFrame(rotate);

      const onInteractionStart = () => {
        isInteracting = true;
        clearTimeout(resumeTimeout);
      };

      const onInteractionEnd = () => {
        clearTimeout(resumeTimeout);
        resumeTimeout = setTimeout(() => {
          isInteracting = false;
        }, 2000);
      };

      const container = containerRef.current;
      container.addEventListener("mousedown", onInteractionStart);
      container.addEventListener("touchstart", onInteractionStart);
      container.addEventListener("mouseup", onInteractionEnd);
      container.addEventListener("touchend", onInteractionEnd);

      cleanupFunctions.push(() => {
        cancelAnimationFrame(animationId);
        clearTimeout(resumeTimeout);
        container.removeEventListener("mousedown", onInteractionStart);
        container.removeEventListener("touchstart", onInteractionStart);
        container.removeEventListener("mouseup", onInteractionEnd);
        container.removeEventListener("touchend", onInteractionEnd);
      });
    });

    cleanupFunctions.push(() => {
      if (viewerRef.current) {
        viewerRef.current.destroy();
        viewerRef.current = null;
      }
    });

    return () => {
      cleanupFunctions.forEach(fn => fn());
    };
  }, [room]);

  // Entry fade-in effect - only on initial load
  useEffect(() => {
    if (!overlayRef.current) return;
    
    // Small delay to ensure everything is ready
    const timer = setTimeout(() => {
      if (overlayRef.current) {
        overlayRef.current.style.transition = "opacity 0.7s ease-out";
        overlayRef.current.style.opacity = "0";
      }
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);

  const handleBack = () => {
    if (overlayRef.current) {
      overlayRef.current.style.transition = "opacity 0.4s ease-in";
      overlayRef.current.style.opacity = "1";
      overlayRef.current.classList.add("room-transition-active");
    }
    setTimeout(() => navigate(`/unit/${plotId}`), 450);
  };

  const navigateToRoom = (newRoomId) => {
    if (overlayRef.current) {
      overlayRef.current.style.transition = "opacity 0.3s ease-in";
      overlayRef.current.style.opacity = "1";
      overlayRef.current.classList.add("room-transition-active");
    }
    setTimeout(() => navigate(`/unit/${plotId}/room/${newRoomId}`), 320);
  };

  // Loading state
  if (isFetching) {
    return (
      <div className="room-loading">
        <div className="room-loading-card">
          <div className="room-loading-icon">🚪</div>
          <div className="room-loading-text">Loading room...</div>
        </div>
      </div>
    );
  }

  // Error state
  if (fetchError || !room) {
    return (
      <div className="room-error">
        <div className="room-error-icon">⚠️</div>
        <h2 className="room-error-title">{fetchError || "Room not found"}</h2>
        <button onClick={() => navigate(-1)} className="room-error-btn">
          ← Go Back
        </button>
      </div>
    );
  }

  return (
    <div className="room-container">
      {/* Header */}
      <div className={`room-header ${showHeader ? 'room-header-visible' : 'room-header-hidden'}`}>
        <button onClick={handleBack} className="room-back-btn">
          ← Back to Unit
        </button>
        
        <span className="room-title">
          🚪 {room.room_label}
        </span>
        
        <span className="room-subtitle">
          Unit {unit?.plot_number}
        </span>

        {/* Other rooms quick navigation */}
        {unit?.rooms?.length > 1 && (
          <div className="room-nav">
            {unit.rooms
              .filter((r) => r.id !== parseInt(roomId))
              .map((r) => (
                <button
                  key={r.id}
                  onClick={() => navigateToRoom(r.id)}
                  className="room-nav-btn"
                >
                  {r.room_label}
                </button>
              ))}
          </div>
        )}
      </div>

      {/* Panorama Container */}
      <div ref={containerRef} className="room-panorama" />

      {/* Transition Overlay */}
      <div ref={overlayRef} className="room-transition" />
    </div>
  );
};

export default RoomPanoramaPage;